module.exports = __webpack_public_path__ + "static/media/paymentLinks.mobile.7ec88c7f.svg";